/** @module */

import { useEffect } from "react";

import { useLocation } from "react-router-dom";

/**
 * Pushes SPA page views to GTM dataLayer.
 * Tracking is handled by GTM in public/index.html — do not use react-ga here
 * (it only supports Universal Analytics and breaks Chrome client-side navigation
 * when initialized with a GA4 G- measurement ID).
 */

const Analytics = () => {

    const location = useLocation ();

    useEffect ( () => {

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push ({

            event: "page_view",

            page_path: location.pathname + location.search,

        });

    }, [ location ] );

    return null;

};

/** @exports Analytics */

export default Analytics;
